const logger: Pick<Console, 'error' | 'warn' | 'info' | 'log'> = {
  error: (...args) => console.error(...args),
  warn: (...args) => console.warn(...args),
  info: (...args) => console.info(...args),
  log: (...args) => console.log(...args),
};

export { logger };
